// TODO more flexible api with optional sumbols
// TODO fix types
//
type Tokens = {
  [key: string]: {
    pattern: RegExp;
  };
};

const maskString = (str: string, mask: string): string => {
  const tokens: Tokens = {
    0: { pattern: /\d/ },
  };
  const checkMaskLeftover = (startIndex: number, aMask: string, char: string): boolean => {
    for (let i = startIndex; i < aMask.length && i < startIndex + 3; i++) {
      const mChar = aMask[i];
      if ((tokens[mChar] && tokens[mChar].pattern.test(char)) || mChar === char) {
        return true;
      }
    }
    return false;
  };
  let maskedString = '';
  let sCharIndex = 0;
  let mCharIndex = 0;
  while (mCharIndex < mask.length && sCharIndex < str.length) {
    const token = tokens[mask[mCharIndex]];
    if (token) {
      if (token.pattern.test(str[sCharIndex])) {
        maskedString += str[sCharIndex];
        sCharIndex++;
        mCharIndex++;
      } else {
        sCharIndex++;
      }
    } else if (mask[mCharIndex] === str[sCharIndex]) {
      maskedString += mask[mCharIndex];
      sCharIndex++;
      mCharIndex++;
    } else if (sCharIndex !== str.length - 1) {
      // Check if it is not a last character in str
      maskedString += mask[mCharIndex];
      mCharIndex++;
    } else if (checkMaskLeftover(mCharIndex, mask, str[sCharIndex])) {
      maskedString += mask[mCharIndex];
      mCharIndex++;
    } else {
      sCharIndex++;
    }
  }
  return maskedString;
};

export default maskString;
